module.exports = __webpack_public_path__ + "img/1726038355589-screenshot-1726038310416.png.9b0cc789.webp";